import styled from 'styled-components';

const RowHeader = styled.div`
  border-top: 9px solid #0eb407;
  width: 210px;
  padding-top: 10px;
  margin-bottom: 50px;
  & > .title,
  .subtitle {
    font-family: MavenPro, sans-serif;
    font-size: 26px;
    font-weight: 500;
    line-height: 1.04;
    text-align: left;
    color: #0eb407;
    white-space: nowrap;
  }
`;

export {RowHeader};
